import React from "react";

// Img
import aboutUs from "./../assets/About_us.png";

// Styles
import "./../styles/About.css";

const About = () => {
  return (
    <>
    <div id="scrollspyabout" className="container-fluid py-3">
      <div className="row py-5">
        <div className="col-md-6">
          <img src={aboutUs} className="img-fluid aboutImg" alt="About" />
        </div>
        <div className="col-md-6 text-start d-flex flex-column justify-content-center text-secondary">
          <h4 className="fw-semibold ">About Us</h4>
          <p>
            Welcome to Radix, a dedicated team of Bachelor of Science in Computer Science
            students from Gordon College. Under the banner of our project,
            Pesopulse, we are committed to simplifying financial management
            through innovative technology. With a shared passion for
            problem-solving and a drive to make a meaningful impact, we're
            working tirelessly to develop a user-friendly accounting solution
            that empowers individuals and businesses alike. Drawing from our
            diverse backgrounds and expertise, we're on a mission to
            revolutionize the way people handle their finances. Join us as we
            embark on this exciting journey to ease the burden of financial
            management and usher in a new era of financial empowerment.
          </p>
          <a href="https://www.facebook.com/profile.php?id=61556271360113">
            <button className="btn fs-6 me-md-2 customButton" type="button">
              Learn More
            </button>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default About;
